module.exports = {
  emptyMessage: 'Por favor, informe seu nome',
  defaultMessage: 'Nome inválido',
};
